import useStepItem from './useStepItem';

interface StepItemProps {
  index: number;
  label?: number;
}

const StepItem = ({ index, label }: StepItemProps) => {
  const { classNames, number } = useStepItem(index);

  return (
    <div className={classNames.container}>
      <span className={classNames.number}>{number}</span>
      <span className={classNames.label}>{label}</span>
    </div>
  );
};

export default StepItem;
